import { IonBackButton, IonButtons, IonCard, IonCardContent, IonContent, IonHeader, IonLabel, IonLoading, IonPage, IonSegment, IonSegmentButton, IonTitle, IonToolbar } from "@ionic/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import { CreateCustomSurvey } from "../../components/SurveyForms/CreateCustomSurvey";
import { Model, SurveyModel } from "survey-core";
// import { json } from "../../components/SurveyForms/json";
// import { LayeredDarkPanelless } from "survey-core/themes/layered-dark-panelless";
import { medlineSurveyJson } from "../../components/SurveyForms/medlineJson";
import SurveyFields from "./SurveyFields";
import { Button, CircularProgress, createTheme, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, TextareaAutosize, ThemeProvider, Typography } from "@mui/material";
import MaterialTable from "material-table";
import tableIcons from "../../components/Notifications/MaterialTableIcons";
import { ApplicationContext, ProviderContext } from "../../ApplicationState";
import * as ApiService from "../../services/ApiService";
import { useHistory, useLocation } from "react-router";
import { arrowBackCircleSharp } from "ionicons/icons";
import { SurveyPDF } from "survey-pdf";
import { Icon } from '@iconify/react';
import "./ReviewSurvey.css";
import { useTranslations } from "../../hooks/useTranslations";

var _ = require("lodash");

export const ReviewSurvey = () => {
    const { userState } = useContext(ApplicationContext)

    const { providerState } = useContext(ProviderContext)
    const [loading, setLoading] = useState(false)
    const [surveys, setSurveys] = useState([])
    const [rejected, setReject] = useState(false)

    const defaultMaterialTheme = createTheme()
    const tableRef = useRef(null)
    const labels = useTranslations()

    const [open, setOpen] = React.useState(false);
    const [selectedDefaults, setSelectedDefaults] = useState('Surveys')
    const [selectedSurvey, setSelectedSurvey] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [selectedSurveyNotes, setSelectedSurveyNotes] = useState([]);



    const groupsColumns = [
        {
            field: "surveyName",
            title: labels.SurveyName,
            width: 0
        },

        {
            field: "surveyDescription",
            title: labels.SurveyDescription,
            width: 0
        },

        // {
        //     field: "details",
        //     title: "Create Survey",
        //     width: 0,
        //     render: rowData => {
        //         return (
        //             <Button
        //                 disabled={!rowData.isEditable}
        //                 onClick={() => {
        //                     history.push("/createSurvey", { rowData: rowData });
        //                 }} variant="contained">Edit</Button>
        //         )
        //     }
        // },

        {
            field: "surveyLink",
            title: labels.Preview,
            width: 0,
            render: rowData => {
                const underReview = rowData?.status
                return (
                    <Button
                        style={{ fontSize: 12, marginRight: 30, cursor: 'pointer' }}
                        hidden={rowData.surveyLink === null ? true : false}
                        onClick={() => {
                            window.open(`/survey/${rowData.id}?access_token=${userState.authenticatedUser.signInUserSession.accessToken.jwtToken}&username=${userState.authenticatedUser.username}&sch_type=${'fromWeb'}&status=${underReview}`, '_blank') //will open in a new tab to bypass login page.
                        }}
                        variant='contained'>
                        {labels.PreviewNewTab}</Button>
                )
            }
        },

        {
            field: "download",
            title: labels.Download,
            width: 0,
            render: rowData => {
                return (
                    <Icon
                        onClick={() => {
                            handleDownload(rowData)
                        }}
                        icon="material-symbols:download"
                        width="30"
                        height="30"
                        style={{
                            alignSelf: 'flex-end',
                            color: 'white',
                            marginLeft: 20,
                            cursor: 'pointer',
                            backgroundColor: '#165fc7',
                            borderRadius: 15,
                            padding: 2
                        }} />


                    // <Button onClick={() => {
                    //     handleDownload(rowData)
                    // }} variant="contained">Download</Button>
                )
            }
        },

        // {
        //     field: "status",
        //     title: "Status",
        //     width: 0,
        //     render: rowData => {
        //         return (
        //             <IonLabel style={{
        //                 color: rowData?.status === "Under Review" ? 'brown' : 'green',
        //                 backgroundColor: rowData?.status === "Under Review" ? '#FFEBE8' : '#E8FFEB', // Light red for review, light green for approved
        //                 padding: '5px 10px', // Optional padding for better UI
        //                 borderRadius: '5px' // Optional rounded corners
        //             }}>{rowData?.status}</IonLabel>

        //         )
        //     }
        // },

        {
            field: "approve",
            title: labels.Approve,
            width: 0,
            render: rowData => {
                const support = userState.authenticatedUser['attributes']['custom:Roles'] === 'Support'
                const rejectedstatus = (rowData?.status === 'Rejected')
                return (
                    <Button
                        disabled={rejectedstatus || support}
                        style={{ cursor: 'pointer', color: 'white' }}
                        onClick={() => {
                            handleApprove(rowData)
                        }} variant="contained">{rejectedstatus ? labels.pending : labels.Approve} </Button>
                )
            }
        },

        {
            field: "reject",
            title: labels.Reject,
            width: 0,
            render: rowData => {
                const support = userState.authenticatedUser['attributes']['custom:Roles'] === 'Support'
                const rejectedstatus = (rowData?.status === 'Rejected')
                return (
                    <Button
                        disabled={rejectedstatus || support}
                        style={{ cursor: 'pointer', color: 'white' }}
                        onClick={() => {
                            handleReject(rowData)
                        }} variant="contained"> {!rejectedstatus ? labels.Reject : labels.Rejected} </Button>
                )
            }
        },

        {
            field: "note",
            title: labels.Note,
            width: 0,
            render: rowData => {
                const support = userState.authenticatedUser['attributes']['custom:Roles'] === 'Support'
                const rejectedstatus = (rowData?.status === 'Rejected')
                return (
                    <Button
                        disabled={rejectedstatus || support}
                        style={{ cursor: 'pointer' }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            openSidebar(rowData)
                        }}
                    >
                        {labels.AddComment ?? 'Add Comment'}
                    </Button>
                )
            }
        },
    ];


    const handleReject = (row) => {

        if (_.isEmpty(selectedSurveyNotes) || selectedSurveyNotes === undefined) {
            return alert("Please add comment before rejecting.");
        }

        const survey = _.filter(selectedSurveyNotes, res => {
            return res?.id === row.id
        })

        if (_.isEmpty(survey)) {
            return alert("Please add comment before rejecting.");
        }

        setLoading(true)

        const data = {
            name: row.surveyName,
            JsonData: row.jsonData,
            description: row.surveyDescription,
            createdOn: row.createdOn,
            UpdatedOn: new Date(),
            userId: row.userId,
            providerId: row.providerId,
            surveyLink: row.surveyLink,
            notes: survey[0].notes
        }

        try {
            ApiService.updateSurveyStatusToReject(userState.authenticatedUser, data, row.id).then((res) => {
                setLoading(false)

                if (res) {
                    const surveyItem = _.map(res?.data, r => {

                        return {
                            id: r.uId,
                            surveyName: r.name,
                            surveyDescription: r.description,
                            surveyLink: r.surveyLink,
                            jsonData: r.jsonData,
                            createdOn: r.createdOn,
                            isEditable: r.isEditable,
                            status: r.status,
                            userId: r.userId,
                            providerId: r.providerId,
                            notes: r.notes
                        }
                    })

                    const sortBydate: any = surveyItem.sort((a, b) => {
                        const date2 = new Date(b.createdOn).getTime();
                        const date1 = new Date(a.createdOn).getTime();
                        return date2 - date1
                    });

                    const sameProviderIdSurveys = sortBydate.filter(item => item.providerId === providerState.providerId);


                    setSurveys(sameProviderIdSurveys)
                    setReject(true)
                    setLoading(false)
                }
            }).catch(error => {
                setLoading(false)
                alert(labels.Somethingwentwrong)
            })
        } catch (ex) {
            setLoading(false)
        }

    }

    const handleApprove = (row) => {

        const survey = _.filter(selectedSurveyNotes, res => {
            return res?.id === row.id
        })

        const data = {
            name: row.surveyName,
            JsonData: row.jsonData,
            description: row.surveyDescription,
            createdOn: row.createdOn,
            UpdatedOn: new Date(),
            userId: row.userId,
            isEditable: false,
            status: 'Approved',
            providerId: row.providerId,
            surveyLink: row.surveyLink,
            notes: _.isEmpty(survey) ? '' : survey[0]?.notes
        }
        setLoading(true)
        try {
            ApiService.createApprovedSurvey(userState.authenticatedUser, data, row.id).then(res => {

                if (res) {
                    const surveyItem = _.map(res?.data, r => {

                        return {
                            id: r.uId,
                            surveyName: r.name,
                            surveyDescription: r.description,
                            surveyLink: r.surveyLink,
                            jsonData: r.jsonData,
                            createdOn: r.createdOn,
                            isEditable: r.isEditable,
                            status: r.status,
                            userId: r.userId,
                            providerId: r.providerId,
                            notes: r.notes
                        }
                    })

                    const sortBydate: any = surveyItem.sort((a, b) => {
                        const date2 = new Date(b.createdOn).getTime();
                        const date1 = new Date(a.createdOn).getTime();
                        return date2 - date1
                    });

                    const sameProviderIdSurveys = sortBydate.filter(item => item.providerId === providerState.providerId);

                    setSurveys(sameProviderIdSurveys)
                    setLoading(false)
                }



            }).catch(error => {
                setLoading(false)
                alert(labels.Somethingwentwrong)
            })
        } catch (ex) {
            setLoading(false)
        }
    }

    const handleClickOpen = (e) => {
        e.stopPropagation();
        setOpen(true);
    };

    const handleClose = (e) => {
        setOpen(false);
    };

    const [text, setText] = React.useState("");

    const handleDownload = (rowData) => {
        const pdfExporter = new SurveyPDF(JSON.parse(rowData.jsonData));
        //const survey = new SurveyModel(JSON.parse(rowData));
        pdfExporter.save("survey-result.pdf");
        //setrowData(rowData?.id)
        // setOpenDeleteModal(true)
    }

    const handleTextChange = (event) => {
        setText(event.target.value);
    };

    useEffect(() => {

        try {
            ApiService.getSurveys(userState.authenticatedUser, providerState.providerId).then(res => {

                const reviewSurveys = res.filter(item => (item.status === 'Under Review') || (item.status === 'Rejected'));


                setLoading(true)
                if (res) {
                    const surveyItem = _.map(reviewSurveys, data => {
                        return {
                            id: data.uId,
                            surveyName: data.name,
                            surveyDescription: data.description,
                            surveyLink: data.surveyLink,
                            jsonData: data.jsonData,
                            createdOn: data.createdOn,
                            isEditable: data.isEditable,
                            status: data.status,
                            userId: data.userId,
                            providerId: data.providerId,
                            notes: data.notes
                        }
                    })

                    const sortBydate: any = surveyItem.sort((a, b) => {
                        const date2 = new Date(b.createdOn).getTime();
                        const date1 = new Date(a.createdOn).getTime();
                        return date2 - date1
                    });

                    setSurveys(sortBydate)
                    setLoading(false)
                }
            }).catch(error => {
                setLoading(false)
                // alert('Issues getting the groups. Please try again.')
            })
        } catch (ex) {
            setLoading(false)
        }

    }, [providerState])


    // Open sidebar with selected note
    const openSidebar = (row) => {
        setText(row?.notes)
        setSelectedSurvey(row);
        setIsSidebarOpen(true);
    };

    // Close sidebar
    const closeSidebar = () => {
        setText('')
        setIsSidebarOpen(false);
    };

    // Save updated note
    const saveNote = () => {
        const survey = { ...selectedSurvey, notes: text }
        setSelectedSurveyNotes([...selectedSurveyNotes, survey])
        setText('')
        closeSidebar();
    };


    return (
        <IonPage style={{ backgroundColor: 'white' }}>
            <Header />
            <IonHeader>
                <IonToolbar color="light">
                    <IonButtons slot="start">
                        <IonBackButton
                            text={labels.Goback}
                            icon={arrowBackCircleSharp}
                            defaultHref="/"
                        />
                    </IonButtons>
                    <IonTitle>{labels.Survey}s</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent style={{ backgroundColor: 'white', overflow: "auto" }}>

                <IonCard style={{ width: "100%", backgroundColor: "white" }}>
                    <IonTitle style={{ color: 'black' }}>{labels.Survey}s {labels.UnderReview}</IonTitle>
                    <IonCardContent>
                        <ThemeProvider theme={defaultMaterialTheme}>
                            <MaterialTable
                                tableRef={tableRef}
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: (
                                            <Typography>
                                                {labels.Nosurveystodisplay}
                                            </Typography>
                                        ),
                                    },
                                    toolbar: {
                                        searchPlaceholder: labels.Search
                                    },
                                    pagination: {
                                        labelRowsPerPage: labels.RowsPerPage,
                                        labelRowsSelect: labels.rows
                                    }


                                }}
                                style={{ width: "100%", fontSize: 16 }}
                                title=""
                                icons={tableIcons}
                                columns={groupsColumns}
                                options={{
                                    pageSizeOptions: [5, 10],
                                    defaultExpanded: true,
                                    rowStyle: rowData => {
                                        const bg = rowData?.status === 'Rejected' ? 'red' : 'white'
                                        const textColor = rowData?.status === 'Rejected' ? 'white' : 'black'
                                        return { backgroundColor: bg, color: textColor };
                                    }
                                }}

                                components={{
                                    OverlayLoading: props => (<div style={{ justifyContent: "center", alignItems: 'center' }}> {labels.Loading}... </div>)
                                }}
                                // isLoading={groupArray.length === 0 || groupArray === null}
                                page={10}
                                data={surveys === null ? [] : surveys}
                            //onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            />
                        </ThemeProvider>
                        <IonLoading
                            cssClass="my-custom-class"
                            isOpen={loading}
                            onDidDismiss={() => setLoading(false)}
                            message={`${labels.Pleasewait}...`}
                            duration={5000}
                        />
                    </IonCardContent>
                </IonCard>

            </IonContent >

            <Drawer
                anchor='right'
                open={isSidebarOpen}
                onClose={() => {
                    closeSidebar()
                }}>
                <div className="container">
                    <TextareaAutosize
                        className="textArea"
                        minRows={3}
                        style={{ height: '50%' }}
                        value={text}
                        onChange={handleTextChange} />
                    <div className="button-container">
                        <button className="close-btn" onClick={closeSidebar}>{labels.Close}</button>
                        <button className="save-btn" onClick={saveNote}>{labels.SAVE}</button>
                    </div>
                </div>

            </Drawer>



            {/* <Dialog open={open} onClose={handleClose}>
                <DialogContent>
                    <DialogContentText>Note</DialogContentText>
                    <TextareaAutosize
                        minRows={3}
                        style={{ width: 200 }}
                        value={text}
                        onChange={handleTextChange} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleNoteSave}>Save</Button>
                    {loading && (
                        <CircularProgress
                            size={24}
                            sx={{
                                color: "#3880ff",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                marginTop: "-12px",
                                marginLeft: "-12px",
                            }}
                        />
                    )}
                </DialogActions>
            </Dialog> */}


        </IonPage>
    )

}